import { FingerprintJSPro } from "@fingerprintjs/fingerprintjs-pro-react";

type UnavailableReason = "threw" | "no_visitor_data";

const SDK_ERROR_TYPES = new Map<string, string>();
Object.entries(FingerprintJSPro ?? {}).forEach(([name, message]) => {
  if (
    name.startsWith("ERROR_") &&
    typeof message === "string" &&
    !SDK_ERROR_TYPES.has(message)
  ) {
    SDK_ERROR_TYPES.set(message, name);
  }
});

export const fingerprintErrorType = (error: unknown): string =>
  (error instanceof Error && SDK_ERROR_TYPES.get(error.message)) ||
  "UnknownError";

export const reportFingerprintUnavailable = (
  userAction: string,
  reason: UnavailableReason,
  error?: unknown
) => {
  window.Sentry?.captureMessage("Device monitoring identifiers unavailable", {
    level: "warning",
    tags: {
      "fingerprint.action": userAction,
      "fingerprint.reason": reason,
      "fingerprint.platform": "web",
      ...(reason === "threw" && {
        "fingerprint.error_type": fingerprintErrorType(error),
      }),
    },
  });
};
